import React, { useContext } from "react";
import "./location-alert-popup.scss";
import { Drawer, Button, Flex, StatusIcon, X } from "@cisco/spaces-dash-lib-styleguide";
import yellowAlert from "../../../assets/images/hierarchy-base/yellow-alert.svg";
import { I18nContext } from "../../../contexts/i18nContext";

export default function LocationDeletePopup(props) {
  const i18n = useContext(I18nContext);
  const { alerts, showAlertPopup, toggleAlerts, showUncategorisedList, wlcCount, showUncategorisedAps, goToLocationEdit, backToAlerts } = props;

  return (
    <Drawer size="lg" isOpen={showAlertPopup}>
      <Flex direction="vertical">
        <Drawer.Heading>
          <Flex justify="space-between">
            <Flex>
              {!showUncategorisedList && (
                <div className="alerts-popup-heading">
                  {" "}
                  {alerts.length} {i18n.t("business-location-details.alerts-text")}
                </div>
              )}
              {showUncategorisedList && (
                <span>
                  <span className="back-link" role="button" onKeyDown={backToAlerts} tabIndex={-1} onClick={backToAlerts}>
                    {i18n.t("business-location-details.back-text")}
                  </span>
                  {i18n.t("business-location-details.uncategorized-aps-text")}
                </span>
              )}
            </Flex>
            <Button.Group>
              <Button kind="tertiary" onClick={toggleAlerts} icon={<X size={16} weight="bold" />} />
            </Button.Group>
          </Flex>
        </Drawer.Heading>
        <Flex>
          <div className="alerts-popup-body">
            {alerts && alerts.length && !showUncategorisedList && (
              <div className="slide-list">
                {alerts.map((alert) => (
                  <React.Fragment key={alert}>
                    {alert === "wlcCount" && wlcCount.apsCount > 0 && (
                      <div>
                        <div className="alert-icon">
                          <img src={yellowAlert} alt="Alert" />
                        </div>
                        <div className="alert-block">
                          <div className="alert-heading">{i18n.t("business-location-details.uncategorized-aps-text")}</div>
                          <div className="alert-desc">
                            <p>
                              {i18n.t("business-location-details.there-are-text")}
                              <strong>{wlcCount.apsCount}</strong>
                              {i18n.t("business-location-details.uncategorized-access-points-info-text")}
                            </p>
                          </div>
                        </div>
                        <div className="alert-action">
                          <span className="alert-link" role="button" onKeyDown={showUncategorisedAps} tabIndex={-2} onClick={showUncategorisedAps}>
                            {i18n.t("business-location-details.view-list-text")}
                          </span>
                        </div>
                      </div>
                    )}

                    {alert === "timezone" && (
                      <div>
                        <StatusIcon status="warning" width={32} height={32} />
                        <div className="alert-block">
                          <div className="alert-heading">{i18n.t("business-location-details.time-zone-data-not-available-text")}</div>
                          <div className="alert-desc">
                            <p>{i18n.t("business-location-details.time-zone-not-updated-in-location-text")}</p>
                            <p>{i18n.t("business-location-details.click-location-name-text")}</p>
                          </div>
                        </div>
                        <div className="alert-action">
                          <Button kind="tertiary" onClick={goToLocationEdit}>
                            {i18n.t("business-location-details.edit-located-data-text")}
                          </Button>
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            )}

            {/* TODO:  */}
          </div>
        </Flex>
      </Flex>
    </Drawer>
  );
}
